/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const Pagination = ({
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  pages,
}) => {

  const paginationStyles = `
    .ai-pagination {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;
    }

    .ai-page-btn {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(30, 41, 59, 0.6);
      border: 1px solid rgba(59, 130, 246, 0.2);
      border-radius: 12px;
      color: #94a3b8;
      font-weight: 600;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      text-decoration: none;
      backdrop-filter: blur(4px);
    }

    .ai-page-btn:hover:not(.disabled) {
      background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(139, 92, 246, 0.1) 100%);
      border-color: rgba(59, 130, 246, 0.5);
      color: #fff;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    }

    .ai-page-btn.active {
      background: linear-gradient(135deg, #3b82f6 0%, #0d6efd 100%);
      border-color: transparent;
      color: #fff;
      box-shadow: 0 0 15px rgba(59, 130, 246, 0.5);
    }

    .ai-page-btn.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      border-color: rgba(255, 255, 255, 0.05);
    }
  `;

  return (
    <>
      <style>{paginationStyles}</style>
      <div className="d-flex justify-content-end mt-4">
        <div className="ai-pagination">
          {/* First Page */}
          <a
            href="#"
            className={`ai-page-btn ${currentPage === 1 ? "disabled" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              if (currentPage > 1) setCurrentPage(1);
            }}
          >
            &laquo;
          </a>

          {/* Previous Pages logic */}
          {currentPage - 2 > 0 && (
            <a
              href="#"
              className="ai-page-btn"
              onClick={(e) => {
                e.preventDefault();
                setCurrentPage((prev) => prev - 2);
              }}
            >
              {currentPage - 2}
            </a>
          )}

          {currentPage - 1 > 0 && (
            <a
              href="#"
              className="ai-page-btn"
              onClick={(e) => {
                e.preventDefault();
                setCurrentPage((prev) => prev - 1);
              }}
            >
              {currentPage - 1}
            </a>
          )}

          {/* Current Page */}
          <a href="#" className="ai-page-btn active" onClick={(e) => e.preventDefault()}>
            {currentPage}
          </a>

          {/* Next Pages logic */}
          {currentPage + 1 <= pages && (
            <a
              href="#"
              className="ai-page-btn"
              onClick={(e) => {
                e.preventDefault();
                setCurrentPage((prev) => prev + 1);
              }}
            >
              {currentPage + 1}
            </a>
          )}

          {currentPage + 2 <= pages && (
            <a
              href="#"
              className="ai-page-btn"
              onClick={(e) => {
                e.preventDefault();
                setCurrentPage((prev) => prev + 2);
              }}
            >
              {currentPage + 2}
            </a>
          )}

          {/* Last Page */}
          <a
            href="#"
            className={`ai-page-btn ${currentPage === pages ? "disabled" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              if (currentPage < pages) setCurrentPage(pages);
            }}
          >
            &raquo;
          </a>
        </div>
      </div>
    </>
  );
};

export default Pagination;
